var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    staticClass: "f-dialog auth-delete-dialog",
    attrs: {
      "title": "删除认证",
      "width": "520px",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "close-on-press-escape": !_vm.submitting,
      "show-close": !_vm.submitting
    },
    on: {
      "update:visible": function updateVisible($event) {
        return _vm.$emit('update:visible', $event);
      }
    }
  }, [_c('div', {
    staticClass: "delete-warning"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _c('span', [_vm._v(" 删除认证后，当前用户不再显示认证用户特权，认证期间产生的数据会继续保留！ ")])]), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.submitting
    },
    model: {
      value: _vm.formData.plannedDelete,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "plannedDelete", $$v);
      },
      expression: "formData.plannedDelete"
    }
  }, [_vm._v(" 计划删除 ")])], 1), _vm.formData.plannedDelete ? _c('el-form-item', {
    attrs: {
      "label": "删除日期",
      "prop": "deleteDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "请选择删除日期",
      "editable": false,
      "disabled": _vm.submitting,
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: _vm.formData.deleteDate,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "deleteDate", $$v);
      },
      expression: "formData.deleteDate"
    }
  }), _c('p', {
    staticClass: "delete-tip"
  }, [_vm._v("按北京时间，在所选日期当天自动删除。")])], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.submitting || !_vm.canLockRegisteredUser
    },
    model: {
      value: _vm.formData.lockRegisteredUser,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "lockRegisteredUser", $$v);
      },
      expression: "formData.lockRegisteredUser"
    }
  }, [_vm._v(" 同步锁定注册用户 ")]), !_vm.canLockRegisteredUser ? _c('p', {
    staticClass: "delete-tip"
  }, [_vm._v(" 当前认证未关联可锁定的分销平台注册用户。 ")]) : _c('p', {
    staticClass: "delete-tip"
  }, [_vm._v(" " + _vm._s(_vm.formData.plannedDelete ? "执行计划删除时" : "立即删除认证时") + "，同时锁定关联的注册用户。 ")])], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('update:visible', false);
      }
    }
  }, [_vm._v(" 取消 ")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.plannedDelete ? "保存删除计划" : "确定删除") + " ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }